import React from 'react';
import "../../styles/home/view_discussions.css";
import { useEffect, useState } from "react";
import { getItem } from "../repositories/movies_and_tvseries";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { deleteField, doc, getDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useSearchContext } from '../chats/searchContext';
import { Link, useLocation, useNavigate } from "react-router-dom";
import ShowAllUsers from "./showAllUsers";
import ReactTooltip from 'react-tooltip';

import discussionsIllustration from "../../images/home/discussions_illustration.png";
import sendMessageIcon from "../../images/chats/send_message_icon.png";
import thoughtIcon from "../../images/home/thought_icon.png";
import fromImage from "../../images/authentication/no_profile.png";
import agreeActive from "../../images/home/agree_icon/agree_active.png";
import agreeInactive from "../../images/home/agree_icon/agree_inactive.png";
import disagreeActive from "../../images/home/disagree_icon/disagree_active.png";
import disagreeInactive from "../../images/home/disagree_icon/disagree_inactive.png";
import deleteIcon from "../../images/chats/delete_icon.png";

const ViewDiscussions = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {setUserId} = useSearchContext();
    const [getBlockShow, setBlockShow] = useState(false);
    const [getYourUserId, setYourUserId] = useState("");
    const [getUserName, setUserName] = useState("");
    const [getUserImage, setUserImage] = useState("");
    const [getSearch, setSearch] = useState("");
    const [getItemName, setItemName] = useState("");
    const [getTypedThought, setTypedThought] = useState("");
    const [getTag, setTag] = useState([]);
    const [getItemDiscussion, setItemDiscussion] = useState([]);
    const [getUpdateItemDiscussion, setUpdateItemDiscussion] = useState([]);
    const [getImagesMap, setImagesMap] = useState({});

    const path = location.pathname.split("/");
    const type = path[path.indexOf("home") + 1];
    const itemId = path.pop();

    const goBack = () => {
        navigate(-1);
    };

    const onTypedThoughtChanged = (thought) => {
        setTypedThought(thought.target.value);
    };

    const onDelete = async(time) => {
        // eslint-disable-next-line no-restricted-globals
        const shouldDelete = confirm("Are you sure you want to delete this thought?");
        if (shouldDelete) {
            const discussionKey = `${type}${itemId}${getItemName[0]}`;
            if (discussionKey !== "") {
                try {
                    const discussionRef = doc(firebaseFirestore, 'User Discussion', discussionKey);
                    const docSnapshot = await getDoc(discussionRef);
                    if (docSnapshot.exists()) {
                        const chatData = docSnapshot.data();
                        if (getYourUserId === chatData[`discussion${time}`]["senderId"]) {
                            await updateDoc(discussionRef, {
                                    
                                [`discussion${time}`]: deleteField(),
                            }, {merge: true});
                        };
                    };
                } catch (error) {
                    console.log(`Error ${error}`);
                    alert("Unable to delete this thought, please try again later.");
                };
            };
        };
    };

    const getUserDetails = async (id) => {
        try {
          const userRef = doc(firebaseFirestore, "User Details", id);
          const userSnapshot = await getDoc(userRef);
          if (userSnapshot.exists()) {
            setUserName(userSnapshot.data().username ?? "");
          }
        } catch (error) {
          console.log(`${error.message}; User Id: ${id}`);
        };
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const options = {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        };
        return date.toLocaleDateString('en-GB', options);
    };

    const formatTime = (timestamp) => {
        const time = new Date(timestamp);
        const options = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true 
        };
        return time.toLocaleTimeString('en-GB', options);
    };

    const onTagUser = () => {
        const lastWord = getTypedThought.split(" ").pop();
        if (lastWord.startsWith("@")) {
            setBlockShow(true);
            setSearch(lastWord.split("@")[1]);
        }else{
            setBlockShow(false);
        }
    }

    const sendThought = async () => {
        const trimmedThought = getTypedThought.trim();
        const discussionKey = `${type}${itemId}${getItemName[0]}`;
        const isUserIdNull = getYourUserId !== null;
        const isUserIdEmpty = getYourUserId !== "";
        const isUserName = getUserName !== "";
        if (trimmedThought !== "" && isUserIdNull && isUserIdEmpty && isUserName) {
            try {
                const date = Date.now().toString();
                const discussionRef = doc(firebaseFirestore, 'User Discussion', discussionKey);
                const discussionData = {
                    senderId: getYourUserId,
                    name: getUserName,
                    message: getTypedThought,
                    react: {},
                    date: date,
                };
            
                const docSnap = await getDoc(discussionRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
            
                    await updateDoc(discussionRef, {
                        [`discussion${date}`]: discussionData,
                    });
                    setTypedThought(''); 
                }else{
                    await setDoc(discussionRef, {
                        [`discussion${date}`]: discussionData,
                    });
                    setTypedThought(''); 
                }
            } catch (error) {
                console.error('Error sending thought: ', error.message, 'Discussion Id: ', discussionKey);
            }
        }
    }

    const retrieveItemDetails = async () => {
        const details = await getItem({itemId, type: type === "movie" ? type : "tv"});
        if (type === "movie") {
            setItemName(details["original_title"] === "" || details["original_title"] === null ? `Unable to retrieve the title of this ${type}` : details["original_title"]);
        } else {
            setItemName(details["original_name"] === "" || details["original_name"] === null ? `Unable to retrieve the title of this ${type}` : details["original_name"]);
        }
    }

    const onReactToDiscussion = async (reaction, getIndex) => {
        const discussionKey = `${type}${itemId}${getItemName[0]}`;
        if (discussionKey !== "") {
            try {
                const discussionRef = doc(firebaseFirestore, 'User Discussion', discussionKey);
                const unsubscribe = await getDoc(discussionRef);
                if (unsubscribe.exists()) {
                    const chatData = unsubscribe.data();
                    let messagesArray = [];
                    Object.keys(chatData).forEach((fieldName) => {
                        getItemDiscussion.map(async (msg, index) => {
                            if (fieldName === `discussion${msg.timestamp}` && getIndex === index) {
                                const messageData = chatData[fieldName];
                                const existingReactions = { ...messageData };
                                const reactionField = getYourUserId;
                                var reactionList = existingReactions["react"];
                                reactionList[reactionField] = reaction;
                                await updateDoc(discussionRef, {
                                    [`${fieldName}.react`]: reactionList,
                                }, { merge: true });
                            }
                        });
                    });

                    // messagesArray.sort((a, b) => a.timestamp - b.timestamp);
                    // setItemDiscussion(messagesArray);
                };        
            } catch (error) {
                console.log(`Error ${error}`);
            }
        };
    }

    const onGetUserImages = async (id) => {
        try {
            const userRef = doc(firebaseFirestore, "User Details", id);
            const userSnapshot = await getDoc(userRef);
            if (userSnapshot.exists()) {
            return userSnapshot.data().image ?? fromImage;
            }
          } catch (error) {
            console.log(`${error.message}; User Id: ${id}`);
            return "";
          }
    }

    useEffect(() => {
        const discussionKey = `${type}${itemId}${getItemName[0]}`;
        if (discussionKey !== "") {
            try {
                const discussionRef = doc(firebaseFirestore, 'User Discussion', discussionKey);
                const unsubscribe = onSnapshot(discussionRef, (docSnapshot) => {
                    if (docSnapshot.exists()) {
                        const chatData = docSnapshot.data();
                        let messagesArray = [];
                        Object.keys(chatData).forEach(async (fieldName) => {
                            if (fieldName.startsWith("discussion")) {
                                const message = chatData[fieldName];
                                const timestamp = parseInt(fieldName.replace('discussion', ''), 10);
                                messagesArray.push({ ...message, timestamp });
                            };
                        });

                        messagesArray.sort((a, b) => a.timestamp - b.timestamp);
                        setItemDiscussion(messagesArray);
                    };
                });

                return () => unsubscribe
            } catch (error) {
                console.log(`Error ${error}`);
            }
        };
    }, [getItemName]);

    useEffect(() => {
        const getUser = onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setYourUserId(user.uid);
                getUserDetails(user.uid);
            }
        });

        return () => getUser();
    }, []);

    useEffect(() => {
        onTagUser();
    }, [getTypedThought]);

    useEffect(() => {
        retrieveItemDetails();
    }, []);

    useEffect(() => {
        const text = getTypedThought.split(" ");
        const lastWord = text.pop();
        if (lastWord.startsWith("@")) {
            setTypedThought(text.join(" ") + " @" + getTag[getTag.length - 1] + " ");
        }
    }, [getTag]);

    useEffect(() => {
        let imagesMap = {};
        getItemDiscussion.map(async (item) => {
            console.log(item);
            imagesMap[item.senderId] = await onGetUserImages(item.senderId);
        });
        
        setImagesMap(imagesMap);
        setUpdateItemDiscussion(getItemDiscussion);
    }, [getItemDiscussion, setItemDiscussion]);

    useEffect(() => {
        const messageContainer = document.querySelector('.home_view_discussions_block');
        if (messageContainer) {
            messageContainer.scrollTop = messageContainer.scrollHeight;
        }
    }, [getItemDiscussion, setItemDiscussion]);
    
    return(
        <div className="home_view_discussions">
            <div className="home_view_discussions_header">
                <p className="home_view_discussions_title">{getItemName}</p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>
            <div className="home_view_discussions_divider"></div>
            <div className="home_view_discussions_block">
                {
                    getUpdateItemDiscussion.length > 0
                    ? getUpdateItemDiscussion.map((disc, index) => {
                        const currentDate = formatDate(disc.timestamp);
                        const messageTime = formatTime(disc.timestamp);
                        const previousMessage = getUpdateItemDiscussion[index - 1];
                        const previousDate = previousMessage ? formatDate(previousMessage.timestamp) : null;

                        let numLikes = 0;
                        let numDislikes = 0;
                        let reaction = "none";
                        for (const i in disc.react) {
                            if (disc.react[i] == "like") {
                                numLikes += 1
                                if (i == getYourUserId) {
                                    reaction = "like"
                                }
                            } else if (disc.react[i] == "dislike") {
                                numDislikes += 1
                                if (i == getYourUserId) {
                                    reaction = "dislike"
                                }
                            }
                        }

                        return (
                            <div className='home_view_discussions_block_disc'>
                                {currentDate !== previousDate && (
                                    <div className="text_message_seperator">
                                        <p>{currentDate}</p>
                                    </div>
                                )}
                                
                                <div key={index} className="home_view_discussions_block_disc_tabs">
                                    <img alt='profile' className="home_view_discussions_disc_image" src={getImagesMap[disc.senderId] === "" || getImagesMap[disc.senderId] === null ? fromImage : getImagesMap[disc.senderId]} />
                                    <div className="home_view_discussions_disc_column">
                                        <Link 
                                            className='home_view_discussions_links' 
                                            to={
                                                disc.name === "" || disc.name === null 
                                                ? null 
                                                : disc.senderId !== getYourUserId
                                                    ? `/main_back/search/${disc.name.toLowerCase()}/profile`
                                                    : `/main_back/profile`
                                            }
                                        >
                                            <p className="home_view_discussions_disc_name" onClick={() => setUserId(disc.senderId)}>{disc.name}</p>
                                        </Link>
                                        <p className="home_view_discussions_disc_message">{disc.message}</p>
                                        <div className="home_view_discussions_react_tab">
                                            <div className="home_view_discussions_react_row">
                                                <img alt='like' className="home_view_discussions_react_img" src={reaction === "like" ? agreeActive : agreeInactive} onClick={() => onReactToDiscussion(`${reaction === "like" ? "none" : "like"}`, index)} />
                                                <p className="home_view_discussions_react_num">{numLikes}</p>
                                            </div>
                                            <div className="home_view_discussions_react_row">
                                                <img alt='dislike' className="home_view_discussions_react_img" src={reaction === "dislike" ? disagreeActive : disagreeInactive} onClick={() => onReactToDiscussion(`${reaction === "dislike" ? "none" : "dislike"}`, index)} />
                                                <p className="home_view_discussions_react_num">{numDislikes}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='home_view_discussions_disc_date_con'>
                                        <p className="home_view_discussions_disc_date">{messageTime}</p>
                                        {
                                            getYourUserId === disc.senderId
                                            ? <img data-tip data-for="delete_discussion" alt='delete' className="home_view_discussions_delete_icon" src={deleteIcon} onClick={() => onDelete(disc.timestamp)} />
                                            : null
                                        }
                                        <ReactTooltip effect='solid' id="delete_discussion" place="top">Delete</ReactTooltip>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                    : <div className="home_view_discussions_block_empty">
                        <img className="home_view_discussions_block_empty_image" src={discussionsIllustration} />
                        <p className="home_view_discussions_block_empty_text">Share your thoughts on {getItemName}</p>
                    </div>
                }
            </div>

            <div className="home_view_discussions_message_input_container">
                <img alt='thought' src={thoughtIcon} className="home_view_discussions_message_input_icon"/>
                <input className="home_view_discussions_message_input_field" placeholder={`${getItemDiscussion.length > 0 ? "Join the" : "Start a"} discussion...`} type="text" value={getTypedThought} onChange={onTypedThoughtChanged} />
                <img alt='send' src={sendMessageIcon} className="home_view_discussions_message_send_icon" onClick={sendThought}/>
                <ShowAllUsers getShow={getBlockShow} getSearch={getSearch} setSearch={setSearch} setTag={setTag} />
            </div>
        </div>
    );
};

export default ViewDiscussions;